export default __webpack_public_path__ + "static/media/08_motor_Informes.96d94259.svg";